import { Chip, Color, colors } from "@mui/material";
import { InvoiceStatusEnum } from "../../types/subscription";
import { useTranslation } from "react-i18next";

function getStatusProps(status: InvoiceStatusEnum, t: Function) {
	let chipColor: Color = colors.grey;
	let label: string = "";

	switch (status) {
		case InvoiceStatusEnum.CANCELLED:
			chipColor = colors.grey;
			label = t("invoicePage.statusString.cancelled");
			break;

		case InvoiceStatusEnum.OVERDUE:
			chipColor = colors.red;
			label = t("invoicePage.statusString.overdue");
			break;

		case InvoiceStatusEnum.PAID:
			chipColor = colors.green;
			label = t("invoicePage.statusString.paid");
			break;

		case InvoiceStatusEnum.UNPAID:
			chipColor = colors.orange;
			label = t("invoicePage.statusString.unpaid");
			break;
	}

	return { chipColor, label };
}

function InvoiceStatusChip(props: { status: InvoiceStatusEnum }) {
	const { t } = useTranslation();
	const { chipColor, label } = getStatusProps(props.status, t);

	return (
		<Chip
			label={label}
			variant="filled"
			size="small"
			sx={{ backgroundColor: chipColor[50], color: chipColor[800], minWidth: 90, textTransform: "uppercase" }}
		/>
	);
}

export default InvoiceStatusChip;
